import {
    PLAN_UPSELL_BANNER_EMPHASIZED_TEXT_CLASSNAME,
    PLAN_UPSELL_BANNER_SUBTLE_TEXT_CLASSNAME,
    PlanUpsellBanner,
} from 'components/shared/banners/PlanUpsellBanner';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { SettingUrls } from 'constants/SettingsUrls';
import { useLabelCountSWR } from '../hooks/useLabelCountSWR';

interface LabelByMonthCountProps {
    loading: boolean;
}

const LabelByMonthCount: React.FC<LabelByMonthCountProps> = ({ loading }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const from = useMemo(() => dayjs().startOf('month').toISOString(), []);
    const to = useMemo(() => dayjs().add(1, 'day').startOf('day').toISOString(), []);

    const { data, isLoading: labelCountLoading } = useLabelCountSWR(from, to);

    const currentlyUsed = useMemo(() => (data ? data.labelCount.toString() : '-'), [data]);

    return (
        <PlanUpsellBanner
            title={t('DASHBOARD.LABEL_COUNT_BANNER.TITLE')}
            description={
                <div className="flex items-center gap-1">
                    <span>{t('DASHBOARD.LABEL_COUNT_BANNER.DESCRIPTION', { count: currentlyUsed })}</span>
                    <s-icon type="info" interestFor="label-count-tooltip"></s-icon>
                    <s-tooltip id="label-count-tooltip">{t('DASHBOARD.LABEL_COUNT_BANNER.TOOLTIP')}</s-tooltip>
                </div>
            }
            buttonLabel={t('DASHBOARD.LABEL_COUNT_BANNER.VIEW_ORDERS')}
            onButtonClick={() => navigate(SettingUrls.orders)}
            loading={loading || labelCountLoading}
            titleClassName={PLAN_UPSELL_BANNER_SUBTLE_TEXT_CLASSNAME}
            descriptionClassName={PLAN_UPSELL_BANNER_EMPHASIZED_TEXT_CLASSNAME}
        />
    );
};

export default LabelByMonthCount;
